import React, { useMemo } from "react";
import { CardMemberLayout } from "@companion-core/shared/app/Components/Blocks/Layouts/CardMemberLayout/CardMemberLayout";
import { BlockProps } from "@companion-core/shared/app/Interfaces/blocks";
import { APISubscriptionData, ComponentData } from "@companion-core/shared/app/Interfaces/API";
import { useConfigStore } from "@companion-core/shared/app/Store/configStore";
import {
  getComponentMedia,
  getComponentsFromBlockItems,
  getComponentText,
} from "@companion-core/shared/app/Utils/componentHelper";
import { useMemberData } from "@companion-core/shared/app/Hooks/member";

export const CardMember = ({ simpleBlockItems }: BlockProps) => {
  const { data: member } = useMemberData();
  const { branding } = useConfigStore();
  const simpleComponents: ComponentData[] = useMemo(
    () => getComponentsFromBlockItems(simpleBlockItems),
    [simpleBlockItems]
  );
  const textComponent: ComponentData | undefined = useMemo(
    () => getComponentText(simpleComponents),
    [simpleComponents]
  );
  const mediaComponent: ComponentData | undefined = useMemo(
    () => getComponentMedia(simpleComponents),
    [simpleComponents]
  );
  const title: string = useMemo(() => textComponent?.title ?? "", [textComponent]);
  const description: string = useMemo(() => textComponent?.description ?? "", [textComponent]);
  const mediaUrl: string = useMemo(() => mediaComponent?.medias?.[0].url ?? "", [mediaComponent]);
  const rectoUrl: string = useMemo(() => branding?.theme?.assets?.cardRectoUrl ?? "", [branding]);
  const versoUrl: string = useMemo(() => branding?.theme?.assets?.cardVersoUrl ?? "", [branding]);
  const fullName: string = useMemo(
    () => (member ? `${member.firstname} ${member.lastname}`.trim().toUpperCase() : ""),
    [member]
  );
  const company: string = useMemo(() => member?.organization?.name?.toUpperCase() ?? "", [member]);
  const subscriptionAttributes = useMemo(
    () =>
      member?.subscriptions?.find(
        (subscription: APISubscriptionData) =>
          subscription.status.toLowerCase() === "active" && subscription.is_primary
      ),
    [member?.subscriptions]
  );
  const expirationDate: string = useMemo(() => {
    const endDate = subscriptionAttributes?.end_date;
    const month = endDate?.slice(5, 7);
    const year = endDate?.slice(0, 4);
    return month && year ? [month, year].join("/") : "";
  }, [subscriptionAttributes]);
  const subscriptionExternalId: string = useMemo(
    () => subscriptionAttributes?.external_id?.toUpperCase() ?? "",
    [subscriptionAttributes]
  );

  return (
    <CardMemberLayout
      title={title}
      description={description}
      mediaUrl={mediaUrl}
      rectoUrl={rectoUrl}
      versoUrl={versoUrl}
      fullName={fullName}
      company={company}
      expirationDate={expirationDate}
      subscriptionExternalId={subscriptionExternalId}
    />
  );
};
